module.exports = __webpack_public_path__ + "static/media/chesca.40dadcac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/chesca.jpg
// module id = 737
// module chunks = 0